import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateUsageIdentifier } from "../services/update-usage-identifier";

export function useUpdateUsageIdentifier() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const mutation = useMutation({
    mutationFn: ({
      source_id,
      usage_identifier,
    }: {
      source_id: string;
      usage_identifier: string | null;
    }) => updateUsageIdentifier(source_id, usage_identifier ?? null),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["session"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["sessions"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Usage Identifier updated successfully",
      });
    },

    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update usage identifier",
        variant: "destructive",
      });
    },
  });

  return mutation;
}
